import { motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/cart/CartContext";

export default function CartBar() {
  const { count, total } = useCart();
  const navigate = useNavigate();
  if (count === 0) return null;
  return (
    <motion.div initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="fixed bottom-5 inset-x-0 z-40 flex justify-center px-6 pointer-events-none" data-testid="cart-bar">
      <button
        onClick={() => navigate("/cart")}
        data-testid="view-cart-button"
        className="pointer-events-auto inline-flex items-center gap-3 rounded-full bg-ember hover:bg-ember-hover text-white font-bold px-10 py-5 text-base tracking-wide uppercase transition-colors duration-300 ember-glow"
      >
        <ShoppingBag className="w-5 h-5" />
        View Cart · {count} item{count > 1 ? "s" : ""} · ${total.toFixed(2)}
      </button>
    </motion.div>
  );
}
